import RiskMembersModule from "./RiskMembersModule";
import RiskMembersSagas from "./redux/RiskMembersSagas";
import RiskMembersReducers from "./redux/RiskMembersReducer";

export default {
  Component: RiskMembersModule,
  moduleName: "riskMembers",
  saga: RiskMembersSagas(),
  reducer: RiskMembersReducers
};
